/* eslint-disable */

/** unique or primary key constraints on table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_model_id" */
  MaterialModelAttributeAttributeIdMaterialModelIdKey = 'material_model_attribute_attribute_id_material_model_id_key',
  /** unique or primary key constraint on columns "material_model_attribute_id" */
  MaterialModelAttributePkey = 'material_model_attribute_pkey'
}

/** select columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_model_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_model_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeSelectColumnArgoMaterialModelAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.material_model_attribute" */
export enum ArgoMaterialModelAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

